import type {
  CampaignSettings,
  CampaignSettingsPatch,
} from '@/apis/generated/dialbunny';
import { apiStoreFactory } from '@/api-store-factory';
import type { StoreEntity } from '@/api-store-factory';
import { STORE } from '@/store-ids';

export type CampaignSettingsStore = StoreEntity<
  CampaignSettings,
  'id',
  {},
  {},
  CampaignSettingsPatch
>;

export const useCampaignSettingsStore = apiStoreFactory<
  CampaignSettingsStore['entity'],
  CampaignSettingsStore['id'],
  CampaignSettingsStore['filter'],
  CampaignSettingsStore['createInput'],
  CampaignSettingsStore['updateInput']
>(
  STORE.CAMPAIGN_SETTINGS,
  { entityIdKey: 'id', supportPagination: false },
  {
    read: async (id: string, { dialbunnyApi }) => {
      return await dialbunnyApi.getCampaignSettings({ campaignSettingsId: id });
    },

    update: async (id: string, campaignSettingsPatch, { dialbunnyApi }) => {
      return await dialbunnyApi.editCampaignSettings({
        campaignSettingsId: id,
        campaignSettingsPatch,
      });
    },
  },
);
